import { useConfigStore, useFnbStore } from '@/stores';
import styles from './styles.module.scss';
import ShopFnbFacilityCategoryButton from '@/components/common/shop-fnb-facility/buttons/category';
import { useFnbCategories } from '@/hooks/poi/useFnbData';
import type { BuildingCategory } from '@/services/dto';
import { useTranslation } from 'react-i18next';
import { SHOP_SEARCH_MODE } from '@/enums/shop';
import clsx from 'clsx';
import { useOrientation } from '@/hooks';

interface FnbSearchByCategoryProps {
    onSelectCategory?: (category: BuildingCategory) => void;
}

const FnbSearchByCategory = ({ onSelectCategory }: FnbSearchByCategoryProps) => {
    const language = useConfigStore((state) => state.config.ui.language);
    const { isHorizontal } = useOrientation();
    const { t } = useTranslation();
    const selectedBuildingId = useFnbStore((state) => state.selectedBuildingId);
    const selectedCategory = useFnbStore((state) => state.selectedCategory);
    const setSelectedCategory = useFnbStore((state) => state.setSelectedCategory);
    const updateFnbContents = useFnbStore((state) => state.updateFnbContents);

    const fnb = useFnbCategories(selectedBuildingId || 'all');

    const handleSelectCategory = (category: BuildingCategory) => {
        setSelectedCategory(category);
        onSelectCategory?.(category);
        updateFnbContents(SHOP_SEARCH_MODE.SEARCH_BY_CATEGORY);
    };

    return (
        <div
            data-region-name="fnb-search-by-category"
            className={clsx(styles['fnb-search-by-category'], {
                [styles['fnb-search-by-category--vertical']]: !isHorizontal,
            })}
            data-region-nav
        >
            {fnb?.map((category) => (
                <ShopFnbFacilityCategoryButton
                    tabIndex={9}
                    data-interactive
                    role="radio"
                    type="button"
                    aria-checked={selectedCategory?.clientCode === category.clientCode}
                    aria-label={category.clientCode === 'all' ? t(category.name[language]) : category.name[language]}
                    key={category.clientCode}
                    title={category.clientCode === 'all' ? t(category.name[language]) : category.name[language]}
                    onClick={() => handleSelectCategory(category)}
                />
            ))}
        </div>
    );
};

export default FnbSearchByCategory;
